export const productRecommendations = ({ products = [], selectedProductIds = [], ownedProductIds = [] }) => (
    products
        .filter(product => (
            !selectedProductIds.includes(product.id)
            && !ownedProductIds.includes(product.id)
            && product.freeAvailable
        ))
        .slice(0, 2)
        .map(product => ({
            productId: product.id,
            name: product.name,
            reason: `Explore ${product.metric || "included usage"} with a free plan.`,
            startingPriceCents: product.startingPriceCents
        }))
);

